<template>
  <div class="p-24">
    <div
      class="bg-static-info-max rounded-lg flex h-[180px] items-center justify-center"
    >
      <RevIllustration
        alt=""
        aria-hidden="true"
        :height="200"
        src="/img/product/obsolete/obsolete-box.png"
        :width="200"
      />
    </div>
    <div class="mt-24">
      <h3 class="heading-1">{{ i18n(translations.mainTitle) }}</h3>
      <div class="text-static-default-low body-2 mt-8">
        {{ i18n(translations.subtitle) }}
      </div>
    </div>
    <RevDivider class="my-24" />
    <div>
      <div class="flex">
        <IconCheckInCircle class="shrink-0" :height="24" :width="24" />
        <div class="ml-16">
          <h4 class="body-1-bold">{{ i18n(translations.item1Title) }}</h4>
          <div class="text-static-default-low body-2 mt-8">
            {{ i18n(translations.item1Text) }}
          </div>
        </div>
      </div>
      <div class="mt-24 flex">
        <IconSparkles class="shrink-0" :height="24" :width="24" />
        <div class="ml-16">
          <h4 class="body-1-bold">{{ i18n(translations.item2Title) }}</h4>
          <div class="text-static-default-low body-2 mt-8">
            {{ i18n(translations.item2Text) }}
          </div>
        </div>
      </div>
      <div class="mt-24 flex">
        <IconFlag class="shrink-0" :height="24" :width="24" />
        <div class="ml-16">
          <h4 class="body-1-bold">{{ i18n(translations.item3Title) }}</h4>
          <div class="text-static-default-low body-2 mt-8">
            {{ i18n(translations.item3Text) }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-56">
      <h4 class="heading-2">{{ i18n(translations.faqTitle) }}</h4>
      <div class="text-static-default-low body-1">
        {{ i18n(translations.faqSubtitle) }}
      </div>
      <RevAccordionList class="mt-24">
        <RevAccordionItem>
          <template #title>
            <span class="heading-3">
              {{ i18n(translations.faqQuestion1) }}
            </span>
          </template>
          <template #body>
            <span>{{ i18n(translations.faqAnswer1) }}</span>
          </template>
        </RevAccordionItem>
        <RevAccordionItem>
          <template #title>
            <span class="heading-3">
              {{ i18n(translations.faqQuestion2) }}
            </span>
          </template>
          <template #body>
            <span>{{ i18n(translations.faqAnswer2) }}</span>
          </template>
        </RevAccordionItem>
        <RevAccordionItem>
          <template #title>
            <span class="heading-3">
              {{ i18n(translations.faqQuestion3) }}
            </span>
          </template>
          <template #body>
            <span>{{ i18n(translations.faqAnswer3) }}</span>
          </template>
        </RevAccordionItem>
      </RevAccordionList>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevAccordionList } from '@ds/components/AccordionList'
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconFlag } from '@ds/icons/IconFlag'
import { IconSparkles } from '@ds/icons/IconSparkles'

import translations from '../ObsoleteComputerModal/ObsoleteComputerModal.translations'

const i18n = useI18n()
</script>
